<template>
    <div class="modalWrapper sendFavorites">
        <form>
            <h1 v-if="recipientType === 'friend'">Send to a friend</h1>
            <h1 v-if="recipientType === 'agent'">Send to Davis Agency</h1>

            <label-input
                type="email"
                label="From"
                v-model="$v.email.$model.from"
                placeholder="me@example.com"
                :validator="$v.email.from"
                error-message="Please enter a valid email address"
            />

            <label-input
                v-if="recipientType === 'friend'"
                type="email"
                label="To"
                v-model="$v.email.$model.to"
                placeholder="friend@example.com"
                :validator="$v.email.to"
                error-message="Please enter a valid email address"
            />

            <label-input
                v-if="recipientType === 'agent'"
                type="email"
                label="To"
                value="Davis Agency"
                :disabled="true"
            />

            <label-input
                label="Subject"
                v-model="$v.email.$model.subject"
                placeholder="Vacation rentals at Davis Agency"
                :validator="$v.email.subject"
                error-message="Please enter a subject"
            />

            <label-input
                label="Body"
                field-body-style="padding-bottom: 50px;"
            >
                <template v-slot:custom>
                    <quill-editor
                        id="emailBody"
                        v-model="email.body"
                        ref="myQuillEditor"
                        :options="editorOptions"
                    />
                </template>
            </label-input>

            <label-input
                label="Properties"
            >
                <template v-slot:custom>
                    <ul class="properties">
                        <li
                            v-for="favorite in favorites"
                            v-text="favorite.name"
                        />
                    </ul>
                </template>
            </label-input>

            <label-input
                :input-class="['hcaptcha']"
            >
                <template v-slot:custom>
                    <vue-hcaptcha
                        ref="hcaptcha"
                        :sitekey="$hcaptchaSitekey"
                        @verify="handleHcaptcha"
                    />
                </template>
            </label-input>

            <label-input>
                <template v-slot:custom>
                    <button
                        v-on:click.prevent="send"
                        :disabled="sendDisabled"
                        v-text="'Send'"
                    />
                    <button
                        v-on:click.prevent="$emit('cancel')"
                        :disabled="ajax.sending"
                        v-text="'Cancel'"
                        style="margin-left: 20px;"
                    />
                </template>
            </label-input>

            <span style="display: inline-block; float: right; margin-right: 30px;" v-if="ajax.sending">{{ ajax.message }}</span>
        </form>
    </div>
</template>

<script>

import axios from 'axios';
import swal from 'sweetalert';
import toast from 'vanillatoasts';
import LabelInput from '../../../_components/form/LabelInput';
import { quillEditor } from 'vue-quill-editor';
import { validationMixin } from 'vuelidate';
import { required, requiredIf, email } from 'vuelidate/lib/validators';
import VueHcaptcha from '@hcaptcha/vue-hcaptcha';

export default {
    components: {
        LabelInput,
        quillEditor,
        VueHcaptcha,
    },
    mixins: [
        validationMixin,
    ],
    props: {
        recipientType: {
            type: String,
        },
        favorites: {
            type: Array,
            default: [],
        },
    },
    data: function() {
        return {
            email: {
                from: '',
                to: '',
                subject: 'Vacation rentals at Davis Agency',
                body: 'Take a look at these vacation rentals I found at Davis Agency.',
            },
            hcaptchaToken: null,
            ajax: {
                sending: false,
                message: '',
            },

            editorOptions: {
                modules: {
                    clipboard: {
                        matchVisual: false,
                    },
                },
            },
        };
    },
    validations: {
        email: {
            from: { required, email },
            to: {
                required: requiredIf(function() {
                    return this.recipientType !== 'agent';
                }),
                email
            },
            subject: { required },
            body: {},
        },
        hcaptchaToken: { required },
    },
    computed: {
        sendDisabled() {
            return this.$v.$invalid || this.$v.$pending || this.ajax.sending;
        },
    },
    methods: {
        send: function() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            let vue = this;
            this.ajax.sending = true;
            this.ajax.message = 'Sending email...';
            axios.post('/api/send-favorites', {
                type: this.recipientType,
                email: vue.email,
                favorites: vue.favorites,
                'h-captcha-response': vue.hcaptchaToken,
            })
                .then(() => {
                    toast.create({
                        text: 'Email sent.',
                        type: 'success',
                        timeout: 1500,
                    });
                    vue.$emit('sent');
                })
                .catch(error => {
                    console.error(error);
                    swal({
                        text: 'Unable to send email.',
                        icon: 'error',
                    });
                })
                .finally(function() {
                    vue.ajax.sending = false;
                    vue.ajax.message = '';
                })
            ;
        },
        handleHcaptcha(token, eKey) {
            this.hcaptchaToken = token;
        },
    },
}
</script>

<style lang="scss">
@import '../../../../../node_modules/quill/dist/quill.core.css';
@import '../../../../../node_modules/quill/dist/quill.snow.css';
@import '../../../../../node_modules/quill/dist/quill.bubble.css';
@import '../../../../../node_modules/bulma/sass/utilities/all';
//@import '~bulma/sass/base/_all';
@import '../../../../../node_modules/bulma/sass/elements/all';
@import '../../../../../node_modules/bulma/sass/form/all';

.field-label {
    flex-grow: 0;
}
.input {
    padding: 0 10px;
}

.sendFavorites {
    form {
        max-height: 90vh;
        overflow: auto;
    }
    label {
        display: inline-block;
        width: 5em;
    }
    .input {
        width: 30em;
    }
    #emailBody {
        width: 100%;
    }
    .properties {
        border: 1px solid #ccc;
        flex-grow: 1;
        padding: 10px 25px;
        margin: 0;
    }
}
</style>
